export default __webpack_public_path__ + "static/media/Correct_SFX.dbeceade.mov";